import { Spinner } from "react-bootstrap";

const LoadingDataSkelton = () => {
  return (
    <>
      <Spinner className="mx-2" animation="border" size={"sm"} />
      <span>
        <strong>Loading...</strong>
      </span>
    </>
  );
};

export default LoadingDataSkelton;
